import React from "react";
import { PublicShell } from "@/components/PublicNav";
import { TrendingUp, Users, MapPin, QrCode } from "lucide-react";

const stats = [
  { icon: Users, n: "50+", l: "Restaurants onboarded" },
  { icon: QrCode, n: "100k+", l: "QR scans served" },
  { icon: TrendingUp, n: "₹1 Cr", l: "Saved in aggregator commissions" },
  { icon: MapPin, n: "10", l: "Cities covered across India" },
];

export const Results = () => (
  <PublicShell>
    <section className="zq-hero-bg">
      <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-20 text-center">
        <span className="zq-pill zq-pill-orange">Results</span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4">Numbers that matter.</h1>
        <p className="text-zq-muted mt-5 max-w-2xl mx-auto">Measurable impact for restaurants of every size — from local cafés to multi-outlet chains.</p>
      </div>
    </section>

    <section className="zq-section pt-0">
      <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {stats.map((s, i) => (
          <div key={i} className="zq-card p-6 text-center" data-testid={`stat-${i}`}>
            <s.icon className="mx-auto text-zq-orange" size={28} />
            <div className="text-3xl font-bold mt-3">{s.n}</div>
            <div className="text-sm text-zq-muted mt-1">{s.l}</div>
          </div>
        ))}
      </div>
    </section>

    <section className="zq-section bg-white border-y border-zq-border">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center">Before vs After ZaykaQR</h2>
        <div className="grid md:grid-cols-2 gap-6 mt-10">
          <div className="zq-card p-6">
            <h4 className="font-semibold text-zq-muted">Before</h4>
            <ul className="mt-3 space-y-2 text-sm text-zq-muted">
              <li>• Paper menus reprinted every price change</li>
              <li>• 25-30% commission to aggregators</li>
              <li>• No data on regulars or popular dishes</li>
              <li>• Multilingual customers underserved</li>
            </ul>
          </div>
          <div className="zq-card p-6 border-zq-orange border-2">
            <h4 className="font-semibold text-zq-orange">After</h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>• Update menu live from your phone</li>
              <li>• 0% commission via WhatsApp orders</li>
              <li>• Track scans, orders, popular items</li>
              <li>• Menus in हिंदी & ગુજરાતી</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </PublicShell>
);
